/** @format */
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionStorageService } from 'sis-common';

const STORAGE_KEY = 'timeline.showSummerPeriod';

@Injectable()
export class ShowSummerPeriodService {
    private readonly sessionStorageService = inject(SessionStorageService);
    private readonly showSummerPeriodState$: BehaviorSubject<boolean>;

    constructor() {
        const initialValue = this.sessionStorageService.getValueOrDefault(STORAGE_KEY, false);
        this.showSummerPeriodState$ = typeof initialValue === 'boolean' ? new BehaviorSubject(initialValue) : new BehaviorSubject(false);
    }

    getShowSummerPeriod(): Observable<boolean> {
        return this.showSummerPeriodState$.asObservable();
    }

    setShowSummerPeriod(value: boolean): void {
        this.sessionStorageService.setValue(STORAGE_KEY, value);
        this.showSummerPeriodState$.next(value);
    }
}
